/**
 * .tuMetrics {"tu1": 0.95, "tu2": 0.96, "tu3": 1, "notes": "compact vs large share media preference", "tuVersion": "2.5"}
 * .help "Last-used compact/large display for image and video embeds becomes the default for new embeds."
 */

export type ShareMediaDisplaySize = 'compact' | 'large';

const STORAGE_KEY = 'currents.shareMediaDisplayDefault';

export function getShareMediaDisplayDefault(): ShareMediaDisplaySize {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'compact' || v === 'large') return v;
  } catch {
    /* ignore */
  }
  return 'compact';
}

export function setShareMediaDisplayDefault(size: ShareMediaDisplaySize): void {
  try {
    localStorage.setItem(STORAGE_KEY, size);
  } catch {
    /* ignore */
  }
}
